import React, { FC, memo } from 'react'

import { UseFormRegister } from 'react-hook-form/dist/types/form'

import ColorInput from 'components/ColorInput'
import { CustomCheckbox } from 'components/CustomCheckbox'

import styles from './styles.module.scss'

interface IProps {
  register: UseFormRegister<any>
  themeBG: string | undefined
  themeColor: string | undefined
  themeButtonBG: string | undefined
  themeButtonColor: string | undefined
  themeBorder: boolean
  setThemeBorder: (withBorder: boolean) => void
}

const WidgetThemeColors: FC<IProps> = ({
  register,
  themeBG,
  themeColor,
  themeButtonBG,
  themeButtonColor,
  themeBorder,
  setThemeBorder,
}) => {
  const _setThemeBorder = (event: React.ChangeEvent<HTMLInputElement>) => {
    setThemeBorder(event.target.checked)
  }

  return (
    <div className={styles.widgetThemeColors}>
      <ColorInput
        placeholder={'Background color'}
        name={'themeBG'}
        register={register}
        value={themeBG}
        boxClassName={styles.colorInput}
      />

      <ColorInput
        placeholder={'Main color'}
        name={'themeColor'}
        register={register}
        value={themeColor}
        boxClassName={styles.colorInput}
      />

      <ColorInput
        placeholder={'Button background color'}
        name={'themeButtonBG'}
        register={register}
        value={themeButtonBG}
        boxClassName={styles.colorInput}
      />

      <ColorInput
        placeholder={'Button text color'}
        name={'themeButtonColor'}
        register={register}
        value={themeButtonColor}
        boxClassName={styles.colorInput}
      />

      <CustomCheckbox
        checked={themeBorder}
        onChange={_setThemeBorder}
        text={'Use outer border'}
        className={styles.checkbox}
      />
    </div>
  )
}

WidgetThemeColors.displayName = 'WidgetThemeColors'

export default memo(WidgetThemeColors)
